import React, { useContext } from "react";
import { AppContext } from "~context/AppContext";

const Footer = () => {
  const { cartActive } = useContext(AppContext);

  return (
    <footer
      className={`footer w-full relative bg-gold text-white ${
        cartActive ? `cart-active` : ``
      }`}
    >
      <section className="grid pb-v2 xs:pb-0">
        <div className="grid-end-12 relative flex align-center justify-between">
          <h3 className="footer__heading universal-sans mt-v3 mb-v2 b1">
            Ready for the next step?
            <br />
            We’ll make sure it’s in the right direction.
          </h3>
        </div>
      </section>

      <section className="footer__addresses w-full relative block pt-v1 xs:pt-0 xs:pb-v5">
        <div className="grid">
          <div className="grid-end-3 xs:grid-end-8 relative xs:mb-v4">
            <p className="mb-1 xs:mb-0 universal-sans b3">Melbourne HQ, VIC</p>
            <a
              href="mailto:blah@apostrophe.xyz"
              className="hover-underline universal-sans b2"
            >
              blah@apostrophe.xyz
            </a>
          </div>

          <div className="grid-end-3 xs:grid-end-8 relative xs:mb-v4">
            <p className="mb-1 xs:mb-0 universal-sans b3">Los Angeles, CA</p>
            <a
              href="mailto:michelle@apostrophe.xyz"
              className="hover-underline universal-sans b2"
            >
              michelle@apostrophe.xyz
            </a>
          </div>

          <div className="footer__addresses__au grid-end-3 xs:grid-end-8 relative xs:mb-v4">
            <p className="mb-1 xs:mb-0 universal-sans b3">IRL</p>
            <a
              href="https://www.google.com/maps/place/1+Silver+St,+Collingwood+VIC+3066,+Australia/@-37.806983,144.9853711,17z/data=!3m1!4b1!4m5!3m4!1s0x6ad642e6b4e6fe97:0xe67a19ff8663c6c1!8m2!3d-37.806983!4d144.9875598"
              target="_blank"
              rel="noreferrer"
              className="hover-underline universal-sans b2"
            >
              1 Silver St Collingwood, Melbourne VIC 3066, Australia Planet
              Earth
            </a>
          </div>

          <div className="grid-end-3 xs:grid-end-8 relative xs:mb-v4">
            <p className="mb-1 xs:mb-0 universal-sans b3">Ring</p>
            <a
              href="tel:+61431 684 093"
              className="hover-underline universal-sans b2"
            >
              +61431 684 093
            </a>
          </div>
        </div>
      </section>

      <section className="footer__acknowledge w-full relative mt-v4 pt-v1 pb-v1 bg-navy text-center xs:text-left text-white">
        <div className="grid">
          <div className="offgrid--no-touch grid-end-12 flex items-center justify-center whitespace-no-wrap xs:whitespace-pre-wrap b3 universal-sans">
            <p>
              <span>
                We acknowledge the traditional custodians of the land on which
                we work; the Wurundjeri people. We have committed to
              </span>
              {` `}
              <a
                href="https://paytherent.net.au/"
                className="underline"
                rel="noopener noreferrer"
                target="_blank"
              >
                paying the rent
              </a>
              <span> </span>
              <span>monthly. Sorry isn’t nearly enough.</span>
            </p>
          </div>
        </div>
      </section>
    </footer>
  );
};

export default Footer;
